





















import ApiClient from '@/common/api'
import BlueButton from '@/views/atoms/BlueButton.vue'
import Global from '@/common/global.js'
import store from '@/store'
import Pager from '@/views/organisms/Pager.vue'

export default
  components: {
    ApiClient
    BlueButton
    Pager
  }
  data: () ->
    members: []
    level: Global.level()
    customerList: store.getters.customerList,
    customer: []
    page: {}
    page_number: '1'

  created: () ->
    store.dispatch('initPostParam')
    store.dispatch('setErrors', [])
    @get_customer()

  methods: {
    click_new: (e) ->
      @$router.push '/partner/tanto_edit'
    showLevel: (v) ->
      for row, index in @level
        if row.id == Number(v)
          return row.name
    customer_delete: (id) ->
      param =
        id: id
      api = new ApiClient()
      data = await api.post('/customs_broker/tanto/delete', param)
      if data.errors.length == 0
        @get_customer()
    get_customer: () ->
      api = new ApiClient()
      data = await api.get('/customs_broker/tanto/list/' + @page_number)
      @members = data.list
      for row, index in await @customerList
        @customer.push(
          id: row.id
          name: row.name
        )
      @page = data.page
    detail_click: (id) ->
      @$router.push '/partner/tanto_edit/detail/' + id
    customerName: (id) ->
      for row, index in @customer
        if row.id == id
          return row.name
      return ''
    move_page: (page) ->
      @page_number = page
      @get_customer()
  }

